module.exports = __webpack_public_path__ + "img/CS-Hybrid_Overview-DA8_1.52df41fc.jpg";